import WySmartTagHomePage from '../components/smartTag/wy-smartTag-dashboard.vue'
export default [
  {
    path: '/smartTag',
    name: 'smartTagDashboard',
    component: WySmartTagHomePage,
    meta: { 
      bindModel: 'chat-autoQA',
      filterAction: 'fetchChatFilters',
      filterNames: ['date', 'contactTypes', 'speakers', 'directions', 'languages', 'channels', 'agentGroups', 'agentTeams', 'agents'],
      headerMenuItems: [
        // {name:'form-filter-dropdown-widget'},
        {name:'date-widget', properties:{disableToday: true}},
        {name:'contactTypes-dropdown-widget'},
        {name:'speakers-dropdown-widget'},
        {name:'interactions-filtering-widget'},
        {name:'interactions-more-filters-widget'}
      ]
    }
  },
]